module.exports = __webpack_public_path__ + "static/media/ІнструкціяФОП_Веб.284bef99.doc";